<template>
  <div>
    <b-nav pills vertical>
      <b-nav-item active>
        <router-link to="/facility"><span>&#187;</span>仪器介绍</router-link>
      </b-nav-item>
      <b-nav-item>
        <a :href="appointment_link" @click="go_to_appointment_platform">
          <span>&#187;</span>预约平台
        </a>
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      appointment_link: "",
    };
  },
  created: function () {
    this.get_appointment_link();
  },
  methods: {
    get_appointment_link: function () {
      let url = "facility/appointment";
      this.$http.get(url).then((response) => {
        this.appointment_link = response.data[0].link;
      });
    },
    go_to_appointment_platform: function () {
      window.open(this.appointment_link);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
